import { helpers } from '@b2bsoft/pos-platform-common';


/**
 * Return WebPOS Sales SDK response data.
 * @memberof posPlatform.wireless
 * @function ssdkResponseData
 * @returns {*} Origin response data
 */
export default helpers.postData;